import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material";

@Component({
    selector: 'app-dialog-confirmar-anexo',
    templateUrl: './dialog-confirmar-exclusao-anexo.component.html',
    styleUrls: ['./dialog-confirmar-exclusao-anexo.component.scss']
})
export class DialogConfirmarExclusaoAnexoComponent implements OnInit {

    public item: string = "";

    constructor(public dialogRef: MatDialogRef<DialogConfirmarExclusaoAnexoComponent>, @Inject(MAT_DIALOG_DATA) public data: any) {

    }

    ngOnInit() {
        this.dialogRef.disableClose = true;
    }

    sair(pode_cancelar: boolean): void {
        this.dialogRef.close({pode_cancelar: pode_cancelar});
    }

}
